'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Column;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Job = require('./Job');

var _Job2 = _interopRequireDefault(_Job);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Column(_ref) {
  var title = _ref.title,
      _class = _ref._class,
      jobs = _ref.jobs;

  return _react2.default.createElement(
    'div',
    { className: 'column' },
    _react2.default.createElement(
      'h2',
      { className: _class },
      title
    ),
    jobs.map(function (_ref2, key) {
      var jobTitle = _ref2.title,
          content = _ref2.content,
          subsectors = _ref2.subsectors,
          fullSlug = _ref2.fullSlug,
          squareImage = _ref2.squareImage,
          matches = _ref2.matches;
      return _react2.default.createElement(_Job2.default, {
        key: key,
        title: jobTitle,
        content: content,
        subsectors: subsectors,
        fullSlug: fullSlug,
        image: squareImage,
        match: (matches || {}).match
      });
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/AllJobs/Column.jsx
// module id = 1139
// module chunks = 0